const isBlobUrl = (url: string | null | undefined): boolean => {
  return !!(url && url.startsWith('blob:'));
};

export default isBlobUrl;
